import { render } from "./Announcements.vue?vue&type=template&id=61ec2fef"
import script from "./Announcements.vue?vue&type=script&lang=js"
export * from "./Announcements.vue?vue&type=script&lang=js"

import "./Announcements.vue?vue&type=style&index=0&id=61ec2fef&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__